import { Component, OnInit, Input } from '@angular/core';
import { ToastController, ModalController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { PushNotication } from 'src/app/_models/pushNotication';
import { AuthService } from 'src/app/_services/auth.service';
import { PushNotificationsService } from 'src/app/_services/pushNotifications.service';
import { AboutUsModalComponent } from '../about-us-modal/about-us-modal.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() type: string;
  @Input() backButtonInvisible: boolean;
  public pushs: PushNotication[] = [];

  constructor(
    private authService: AuthService,
    private pushNotificationsService: PushNotificationsService,
    public toastController: ToastController,
    public modalCtrl: ModalController
  ) {
    if (typeof this.backButtonInvisible == 'undefined') {
      this.backButtonInvisible = false;
    }

  }

  ngOnInit() {
    this.authService.tokenSubject.subscribe((token) => {
      if (token != null) {
        setTimeout(() => {
          this.pushNotificationsService.all()
            .subscribe(pushs => this.pushs = pushs);
        }, 2500);
      }
    });
  }

  openNotifications() {
    if (this.pushs.length > 0) {
      for (let push of this.pushs) {
        this.presentToast(push.title, push.summary, true);
      }
    }
  }

  openContactForm() {
    this.presentToast('Contact form', 'Shows contact form');
  }

  async presentToast(title: string = '', message: string = '', clearPushs: boolean = false) {
    const toast = await this.toastController.create({
      header: title,
      message: message,
      icon: 'information-circle',
      position: 'top',
      duration: 5000,
      buttons: [
        {
          text: 'Fechar',
          role: 'cancel',
          handler: () => {
            if (clearPushs) {
              this.pushs = [];
            }
          }
        }
      ]
    });

    toast.present();
  }

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: AboutUsModalComponent,
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
  }

}
